module.exports = __webpack_public_path__ + "img/f3-4.9319459b.png";